import { Plus, Trash2, GripVertical } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import type { HelpFooterLink } from '@/pages/HelpCenter/types'

interface NavLinksEditorProps {
  links: HelpFooterLink[]
  onChange: (links: HelpFooterLink[]) => void
}

const MAX_NAV_LINKS = 6

// Flat list of header nav links (label + url). External http(s) links open in a
// new tab; relative "/path" links stay in the help center. Mirrors the footer
// links editor but without columns.
export function NavLinksEditor({ links, onChange }: NavLinksEditorProps) {
  const add = () => onChange([...links, { label: '', url: '' }])
  const remove = (i: number) => onChange(links.filter((_, j) => j !== i))
  const set = (i: number, patch: Partial<HelpFooterLink>) =>
    onChange(links.map((l, j) => (j === i ? { ...l, ...patch } : l)))

  return (
    <div className="space-y-2">
      {links.map((link, i) => (
        <div key={i} className="flex items-center gap-2">
          <GripVertical className="size-4 shrink-0 text-muted-foreground/50" />
          <Input value={link.label} onChange={e => set(i, { label: e.target.value })} placeholder="Label (e.g. Pricing)" className="flex-1" />
          <Input value={link.url} onChange={e => set(i, { url: e.target.value })} placeholder="https://… or /path" className="flex-1" />
          <Button variant="ghost" size="icon" onClick={() => remove(i)} aria-label="Remove link">
            <Trash2 className="size-4" />
          </Button>
        </div>
      ))}
      <Button variant="outline" size="sm" onClick={add} disabled={links.length >= MAX_NAV_LINKS}>
        <Plus className="size-4" /> Add nav link
      </Button>
    </div>
  )
}
